<template>
    <div class="container-render-post" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
         <div class="render-post hide-scrollbar render-post-facebook">
            <div class="post-content">
                <div class="post-header">
                    <div class="img-pages">

                        <template v-for="(page, index) in pages.slice(0,pages.length == 4 ? 4 : 3)">
                            <Tooltip 
                                :active="page.iconEdited" 
                                :key="index" 
                                :text="'Voir les modifications apportées'" 
                                position="right" 
                                :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`" 
                                @click="()=>{page.iconEdited ? $emit('clickPage', page.id) : openFacebookPage(page)}"
                            >
                                <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                            </Tooltip>
                        </template>

                        <div class="page count" v-if="pages.length > 4">
                            +{{ pages.length - 3 }}
                        </div>
                    </div>

                    <div class="info">
                        <div class="info-top">
                            <p class="name" v-if="pages.length == 1" @click="openFacebookPage(pages[0])">{{ pages[0].name }} </p>
                            <p class="location" v-if="place && place.name">{{ $t('dash.post-creator.render.is-at') }} <span class="value">{{ place.name }}</span></p>
                        </div>
                      
                        <div class="date">{{ datePost ? dateFormatPost : 'A l\'instant' }} • <i class="fa-solid fa-earth-americas"></i></div>
                    </div>
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-text" v-if="text">
                    <p v-html="textTranslate"></p>
                </div>

                <div class="snippet" v-if="snippet.link">
                    <SnippetNetwork :link="snippet.link" :titleDefault="snippet.title" :imageUrlDefault="snippet.imageUrl" :descriptionDefault="snippet.description"></SnippetNetwork>
                </div>
                <div v-else-if="isMixedMedia" class="post-medias-carousel">
                    <div v-if="medias.length == 1" class="media">
                        <div v-if="medias[0].type.startsWith('video/')" class="media-video" :class="{videoPlayed:videoPlayed == medias[0].id}" @click="togglePlayPause(medias[0].id)">
                            <img v-if="getThumbnailUrl(medias[0]) && videoPlayed !== medias[0].id" :src="getThumbnailUrl(medias[0])" alt="" class="imagePreview">
                            <video ref="videoPlayer" :mediaId="medias[0].id" playsinline preload="metadata" class="video" loop :autoPlay="videoPlayed == medias[0].id" :src="medias[0].url" :type="medias[0].type"></video>
                        </div>
                        <img v-else :src="medias[0].url" alt="">
                    </div>
                    <div v-else class="carousel hide-scrollbar" @wheel="handleHorizontalScroll">
                        <div class="item" v-for="(media,i) in medias.slice(0,20)" :key="media.id" :class="{['item'+i] : true}">
                            <div v-if="media.info.type.startsWith('video/')" class="media-video" :class="{videoPlayed:videoPlayed == media.id}" @click="togglePlayPause(media.id)">
                                <img v-if="getThumbnailUrl(media) && videoPlayed !== media.id" :src="getThumbnailUrl(media)" alt="" class="imagePreview">
                                <video ref="videoPlayer" :mediaId="media.id" playsinline preload="metadata" class="video" loop :autoPlay="videoPlayed == media.id" :src="media.url" :type="media.info.type"></video>
                            </div>
                            <img v-else :src="media.url" alt="">
                        </div>
                    </div>
                </div>
                <div v-else-if="medias.filter(media => media).length" :class="'post-medias media'+medias.length">
                    <div 
                        v-for="(media,i) in medias.slice(0,4)" 
                        v-if="media" 
                        class="media" 
                        :key="media.id"
                    >
                        <div class="count" v-if="i == 3 && medias.length > 4">+{{ medias.length - 3}}</div>
                            
                        <div v-if="media.info.type.startsWith('video/')"  class="media-video" :class="{videoPlayed:videoPlayed == media.id}" @click="togglePlayPause(media.id)">
                            <img v-if="media.imagePreview && videoPlayed !== media.id" :src="media.imagePreview.url" alt="" class="imagePreview">
                            <video 
                                ref="videoPlayer" 
                                :mediaId="media.id" 
                                playsinline 
                                preload="metadata" 
                                class="video" 
                                loop 
                                :autoPlay="videoPlayed == media.id"
                                :src="media.url" 
                                :type="media.info.type"
                            >
                              
                            </video>
                        </div>
                        <img v-else :src="media.url" alt="">
                    </div>
                </div>

                <div class="post-empty" v-if="!text && !medias.length && !snippet.link"></div>
                <div class="post-footer">
                    <div class="reaction">
                        <i class="fa-regular fa-thumbs-up"></i>
                        J'aime
                    </div>
                    <div class="comments">
                        <i class="fa-regular fa-comment"></i>
                        Commenter
                    </div>
                    <div class="share">
                        <i class="fa-regular fa-share"></i>
                        Partager
                    </div>
                </div>
                <div class="comment-first" v-for="comment in commentsTranslate" >
                    <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] ?  'img/avatar.jpg' : pages[0].avatar" alt="">
                    <div class="content-comment">
                        <div class="auteur"><i class="fa-solid fa-microphone-stand"></i>Auteur</div>
                        <p class="page-name" v-if="pages.length == 1">{{ pages[0].name }}</p>
                        <p class="comment" v-html="comment"></p>
                    </div>
                </div>
            </div>
        </div>

        <SelectPlace v-if="modes.includes('addPlaceMode')" 
            @close="closeContentOverflow"
            :placeSelected="place"
            :position="positionFormOverlay"
            :network="'facebook'"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import SelectPlace from '../../formOverlay/selectPlace.vue';
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],

        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip,
            SelectPlace
        },

        props: {
            pages: {
                type: Array,
                default: () => [] 
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },
            
            mentions : {
                type: Object,
                default: ()=>({})
            },

            modes: {
                type: Array,
                default:()=>[] 
            },

            positionFormOverlay: {
                type: String,
                default: 'left'
            },

            place: {
                type: Object,
                default: undefined
            },
        },
        data() {
            return {
                fontSize: 0,
                videoPlayed: null
            }
        },

        methods: {
            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
            },

            togglePlayPause(mediaId) {
                console.log('togglePlayPause',mediaId,this.$refs.videoPlayer)
                if (!this.$refs.videoPlayer || !this.$refs.videoPlayer.length) {
                    this.videoPlayed=null
                    return
                }
                this.$refs.videoPlayer.forEach(videoEl => {
                    if (videoEl.getAttribute('mediaId') == mediaId) {
                       if (videoEl.paused) {
                            videoEl.play();
                            this.videoPlayed=mediaId
                        } else {
                            videoEl.pause();
                            this.videoPlayed=null
                        }
                    }else{
                        videoEl.pause();
                    }
                });
                
                
            },

            openFacebookPage(page) {
                const url = `https://www.facebook.com/${page.network_id}/`;
                window.open(url, '_blank');
            },

            handleHorizontalScroll(event) {
                if (event.deltaX == 0) {
                    event.preventDefault();
                    const scrollContainer = event.currentTarget;
                    scrollContainer.scrollLeft += event.deltaY;
                }
            },

            getThumbnailUrl(media) {
                return media && media.imagePreview && media.imagePreview.url ? media.imagePreview.url : null
            }
        },

        watch: {
        },

        computed: {
            isMixedMedia() {
                if (!this.medias.length) return false
                const hasImage = this.medias.some(m => m && m.info.type && !m.info.type.startsWith('video/'))
                const hasVideo = this.medias.some(m => m && m.info.type && m.info.type.startsWith('video/'))
                return hasImage && hasVideo
            },

            dateFormatPost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            textTranslate() {
                //return this.text

                let mentionCount = 0;
                return this.text.substring(0,63206).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        if (mentionCount < 20 && mention.mention && mention.mention.facebook) {
                            mentionCount++
                            return `<span class="mention">${mention.mention.facebook.name}</span>`
                        }else{
                            return mention.textDefault;
                        } 
                    }
                    return match;
                })
                .replace(/\n/g, '<br>')
                .replace(
                    /https?:\/\/[^<\s]+(?=<br>|\s|$)/g, // S'arrête avant <br>, espace ou fin de chaîne
                    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                )
              
            },
     
            commentsTranslate() {
                //return this.text
                let mentionCount = 0;
                return this.comments.map(comment => (
                    comment.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {
                    const mention = this.mentions[id];
                        if (mention) {
                            if (mentionCount < 20 && mention.mention && mention.mention.facebook) {
                                mentionCount++
                                return `<span class="mention">${mention.mention.facebook.name}</span>`
                            }else{
                                return mention.textDefault;
                            }
                        }
                        return match;
                    })
                    .replace(/\n/g, '<br>')
                    .replace(
                        /https?:\/\/[^<\s]+(?=<br>|\s|$)/g, // S'arrête avant <br>, espace ou fin de chaîne
                        (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                    )
                ));   
            }
        },
    }
</script>
